import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/common/Skeleton';

export function StripeSkeleton() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" variant="text" />
        </CardHeader>
        <CardContent className="space-y-3">
          <div>
            <Skeleton className="h-4 w-24 mb-2" variant="text" />
            <Skeleton className="h-5 w-full max-w-[280px]" variant="text" />
            <Skeleton className="h-6 w-20 rounded-full mt-2" variant="rectangular" />
          </div>
          <Skeleton className="h-4 w-3/4" variant="text" />
          <Skeleton className="h-4 w-32" variant="text" />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-40" variant="text" />
        </CardHeader>
        <CardContent className="space-y-2">
          <Skeleton className="h-5 w-28" variant="text" />
          <Skeleton className="h-4 w-20" variant="text" />
        </CardContent>
      </Card>

      <Skeleton className="h-12 w-full rounded-md" variant="rectangular" />

      <div>
        <Skeleton className="h-6 w-36 mb-3" variant="text" />
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-3 p-3 rounded-lg border border-gray-200">
              <Skeleton className="h-4 w-12" variant="text" />
              <Skeleton className="h-4 w-16" variant="text" />
              <Skeleton className="h-5 w-16 rounded-full ml-auto" variant="rectangular" />
            </div>
          ))}
        </div>
      </div>

      <div>
        <Skeleton className="h-6 w-32 mb-3" variant="text" />
        <div className="space-y-2">
          {[1, 2].map((i) => (
            <div key={i} className="flex items-center gap-3 p-3 rounded-lg border border-gray-200">
              <Skeleton className="h-4 w-24" variant="text" />
              <Skeleton className="h-4 w-20" variant="text" />
              <Skeleton className="h-5 w-20 rounded-full ml-auto" variant="rectangular" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
